import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { ISiteControlModel } from '../models'

export class GetSiteControlApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/general/siteControl',
      requesterInfo,
    })
  }

  public async getSiteControl(): Promise<ISiteControlModel> {
    return await this.getAsync<ISiteControlModel>()
  }
}
